<template>
  <section :class="['common-section', type]" :id="id">
    <div class="section-wrapper">
      <template v-if="type === 'footer'">
        <div class="footer-container">
          <div class="footer-content">
            <div class="footer-main">
              <div class="footer-left">
                <div class="footer-logo">
                  <img src="@/assets/logo.png" alt="杭州坤时">
                </div>
                <div class="qrcode">
                  <img src="@/assets/qrcode.png" alt="杭州坤时二维码">
                  <p>{{ $t('footer.qrcode') }}</p>
                </div>
              </div>
              <div class="footer-center">
                <div class="footer-links">
                  <div class="link-group">
                    <h4>{{ $t('nav.about') }}</h4>
                    <ul>
                      <li><a href="#" @click.prevent="navigateToAboutSection('profile')">{{ $t('about.profile.title') }}</a></li>
                      <li><a href="#" @click.prevent="navigateToAboutSection('culture')">{{ $t('about.culture.title') }}</a></li>
                      <li><a href="#" @click.prevent="navigateToAboutSection('history')">{{ $t('about.history.title') }}</a></li>
                      <li><a href="#" @click.prevent="navigateToAboutSection('honors')">{{ $t('about.honors.title') }}</a></li>
                      <li><a href="#" @click.prevent="navigateToAboutSection('partners')">{{ $t('about.partners.title') }}</a></li>
                    </ul>
                  </div>
                  <div class="link-group">
                    <h4>{{ $t('nav.solution') }}</h4>
                    <ul>
                      <li><a href="#" @click.prevent="scrollToSection('unmanned')">{{ $t('solution.unmanned.title') }}</a></li>
                      <li><a href="#" @click.prevent="scrollToSection('fuel')">{{ $t('solution.fuel.title') }}</a></li>
                      <li><a href="#" @click.prevent="scrollToSection('unloading')">{{ $t('solution.unloading.title') }}</a></li>
                      <li><a href="#" @click.prevent="scrollToSection('inspection')">{{ $t('solution.inspection.title') }}</a></li>
                      <li><a href="#" @click.prevent="scrollToSection('coreTech')">{{ $t('solution.coreTech.title') }}</a></li>
                    </ul>
                  </div>
                  <div class="link-group">
                    <h4>{{ $t('nav.news') }}</h4>
                    <ul>
                      <li><router-link to="/news">{{ $t('footer.companyNews') }}</router-link></li>
                    </ul>
                  </div>
                  <div class="link-group">
                    <h4>{{ $t('nav.contact') }}</h4>
                    <ul>
                      <li><router-link to="/contact">{{ $t('footer.contactInfo') }}</router-link></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="footer-right">
                <div class="service-hotline">
                  <h4>{{ $t('footer.hotline') }}</h4>
                  <p class="phone">0571-87352558</p>
                  <p class="work-time">{{ $t('footer.workTime') }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="copyright">
            <div class="copyright-content">
              <p>{{ $t('footer.copyright') }}</p>
              <p class="icp">{{ $t('footer.icp') }}</p>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CommonSection',
  props: {
    type: {
      type: String,
      required: true,
      validator: value => ['news', 'footer'].includes(value)
    },
    id: {
      type: String,
      required: true
    }
  },
  emits: ['scroll-to-section', 'section-change'],
  methods: {
    navigateToAboutSection(section) {
      // 如果已经在 about 页面，直接滚动
      if (this.$route.path === '/about') {
        this.$nextTick(() => {
          const element = document.getElementById(section);
          if (element) {
            const headerHeight = 90;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = window.pageYOffset + elementPosition - headerHeight;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            history.replaceState(null, null, `#${section}`);
            this.$emit('section-change', section);
          }
        });
      } else {
        // 如果不在 about 页面，先导航到 about 页面
        this.$router.push({
          path: '/about',
          hash: section
        }).then(() => {
          // 等待页面加载完成后再滚动
          setTimeout(() => {
            const element = document.getElementById(section);
            if (element) {
              const headerHeight = 90;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = window.pageYOffset + elementPosition - headerHeight;
              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });
              this.$emit('section-change', section);
            }
          }, 100); // 给页面一点加载时间
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err);
          }
        });
      }
    },

    scrollToSection(section) {
      // 严格判断是否是解决方案相关的 section
      const isSolutionSection = ['unmanned', 'fuel', 'unloading', 'inspection', 'coreTech'].includes(section);
      
      if (!isSolutionSection) {
        // 如果不是解决方案相关的 section，使用 navigateToAboutSection
        this.navigateToAboutSection(section);
        return;
      }

      // 处理解决方案页面的跳转
      if (this.$route.path === '/solutions') {
        // 如果已经在解决方案页面，直接滚动
        const element = document.getElementById(section);
        if (element) {
          const headerHeight = 90;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = window.pageYOffset + elementPosition - headerHeight;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          history.replaceState(null, null, `#${section}`);
          this.$emit('section-change', section);
        }
      } else {
        // 如果不在解决方案页面，先跳转
        this.$router.push({
          path: '/solutions',
          hash: section
        }).then(() => {
          this.$nextTick(() => {
            const element = document.getElementById(section);
            if (element) {
              const headerHeight = 90;
              const elementPosition = element.getBoundingClientRect().top;
              const offsetPosition = window.pageYOffset + elementPosition - headerHeight;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
              });

              this.$emit('section-change', section);
            }
          });
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err);
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common-section {
  position: relative;
  z-index: 1;
  width: 100%;
  &.news {
    background-color: #f8f9fa;
    padding: 80px 0;
    display: flex;
    align-items: center;

    .section-wrapper {
      max-width: 1400px;
      margin: 0 auto;
      padding: 0 20px;
      width: 100%;
    }
  }

  &.footer {
    background-color: #fff;
    display: flex;
    align-items: flex-start;

    .section-wrapper {
      width: 100%;
    }

    .footer-container {
      width: 100%;
      background-color: #f6f6f6;
      
      .footer-content {
        max-width: 1400px;
        margin: 0 auto;
        padding-top: 50px;
        margin-bottom: 40px;
      }

      .footer-main {
        display: flex;
        justify-content: space-between;
        padding-bottom: 40px;
        border-bottom: 1px solid rgba(192, 165, 165, 0.2);

        @media (max-width: 1000px) {
          flex-direction: column;
          align-items: center;
          gap: 30px;
          padding: 0 20px 30px;

          .footer-left {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0;
          }

          .footer-center {
            width: 100%;
            display: block;
            margin-top: 20px;

            .footer-links {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              gap: 20px;
              margin: 0;

              .link-group {
                flex: 1 1 calc(50% - 20px);
                min-width: 140px;
                text-align: center;
                margin-bottom: 0;

                h4 {
                  font-size: 16px;
                  margin-bottom: 12px;
                }

                ul {
                  li {
                    margin-bottom: 8px;

                    a {
                      font-size: 14px;
                      color: #666;
                      display: inline-block;
                      padding: 4px 8px;
                      border-radius: 4px;
                      transition: all 0.3s ease;

                      &:hover {
                        color: #409EFF;
                        background: rgba(64, 158, 255, 0.1);
                      }
                    }
                  }
                }
              }
            }
          }

          .footer-right {
            width: 100%;
            text-align: center;
            margin-top: 20px;

            .service-hotline {
              h4 {
                font-size: 16px;
                margin-bottom: 10px;
              }

              .phone {
                font-size: 24px;
                margin-bottom: 5px;
              }

              .work-time {
                font-size: 14px;
              }
            }
          }
        }

        .footer-left {
          width: 200px;
          
          .footer-logo {
            margin-bottom: 20px;
            
            img {
              height: 45px;
            }
          }

          .qrcode {
            text-align: center;
            
            img {
              width: 120px;
              height: 120px;
              margin-bottom: 10px;
            }
            
            p {
              font-size: 14px;
              color: #666;
            }
          }
        }

        .footer-center {
          flex: 1;
          display: block;

          .footer-links {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin: 10px 0 0 70px;

            .link-group {
              margin-bottom: 20px;
              min-width: 160px;

              h4 {
                font-size: 18px;
                margin-bottom: 20px;
                font-weight: 500;
                color: #333;
              }

              ul {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                  margin-bottom: 12px;

                  a {
                    color: #999;
                    text-decoration: none;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    cursor: pointer;

                    &:hover {
                      color: #409EFF;
                    }
                  }
                }
              }
            }
          }
        }

        .footer-right {
          width: 213px;
          text-align: right;

          .service-hotline {
            h4 {
              font-size: 16px;
              color: #333;
              margin-bottom: 15px;
              font-weight: 500;
            }

            .phone {
              font-size: 24px;
              color: #409EFF;
              font-weight: 500;
              margin-bottom: 10px;
            }

            .work-time {
              font-size: 14px;
              color: #999;
            }
          }
        }
      }

      .copyright {
        text-align: center;
        color: #fff;
        font-size: 14px;
        background: #1d2088;
        padding: 15px 0;
        width: 100%;

        .copyright-content {
          max-width: 1400px;
          display: flex;
          justify-content: center;

          margin: 0 auto;
          padding: 0 20px;
          color: #fff;
          font-size: 16px;
          @media (max-width: 1000px) {
            flex-direction: column;
            align-items: center;
            gap: 5px;
            font-size: 12px;
          }
        }

        p {
          margin: 5px 0;
        }

        .icp {
          color: #fff;
          font-size: 16px;

          @media (max-width: 1000px) {
            font-size: 12px;
          }
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .common-section {
    &.footer {
      .footer-container {
        .footer-main {
          .footer-center {
            .footer-links {
              .link-group {
                min-width: 140px;
              }
            }
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .common-section {
    &.footer {
      .footer-container {
        .footer-main {
          flex-wrap: wrap;
          gap: 20px;
          padding: 0 20px 30px;

          .footer-left {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0;
          }

          .footer-center {
            width: 100%;
            margin: 0;

            .footer-links {
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              gap: 20px;
              margin: 0;

              .link-group {
                flex: 1;
                min-width: auto;
                margin-bottom: 0;
                text-align: left;
              }
            }
          }

          .footer-right {
            width: 100%;
            text-align: center;
            margin-top: 20px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .common-section {
    &.footer {
      .footer-container {
        .footer-main {
          .footer-center {
            .footer-links {
              display: flex;
              flex-wrap: wrap;
              gap: 15px;

              .link-group {
                flex: 1 1 calc(50% - 15px);
                min-width: 140px;
                text-align: left;
              }
            }
          }
        }

        .copyright {
          .copyright-content {
            flex-direction: row;
            justify-content: center;
            gap: 20px;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style> 